import DOMPurify from 'dompurify';

export const RICH_TEXT_HTML_ALLOWED_TAGS = [
  'b',
  'strong',
  'i',
  'em',
  'u',
  'p',
  'span',
  'br',
  'a',
] as const;

export const RICH_TEXT_HTML_ALLOWED_ATTR = ['href', 'target', 'rel'] as const;

export const HTML_ENTITY_DECODE_FALLBACKS: ReadonlyArray<readonly [RegExp, string]> = [
  [/&lt;/gi, '<'],
  [/&gt;/gi, '>'],
  [/&amp;/gi, '&'],
  [/&quot;/gi, '"'],
  [/&#39;/g, "'"],
];

const decodeHtmlEntities = (raw: string): string => {
  if (!raw.includes('&')) {
    return raw;
  }

  if (typeof document === 'undefined') {
    return HTML_ENTITY_DECODE_FALLBACKS.reduce(
      (decoded, [pattern, replacement]) => decoded.replace(pattern, replacement),
      raw,
    );
  }

  const textarea = document.createElement('textarea');
  textarea.innerHTML = raw;
  return textarea.value;
};

export const sanitizeRichTextHtml = (raw: string): string => {
  const trimmed = raw.trim();
  if (!trimmed) {
    return '';
  }

  const decoded = decodeHtmlEntities(trimmed);

  return DOMPurify.sanitize(decoded, {
    ALLOWED_TAGS: [...RICH_TEXT_HTML_ALLOWED_TAGS],
    ALLOWED_ATTR: [...RICH_TEXT_HTML_ALLOWED_ATTR],
  });
};
